import lodash from 'lodash'

window.lodash = lodash
window._ = lodash

import '../src/react/startup/registration'
